import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "correction-explanation-block"
};
const _hoisted_2 = {
  class: "correction-explanation"
};
const _hoisted_3 = {
  class: "explanation-title"
};
const _hoisted_4 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('view.speach.quiz.question.explanationLabel')), 1), _createElementVNode("span", {
    class: "explanation-detail",
    innerHTML: _ctx.questionCorrection
  }, null, 8, _hoisted_4)])]);
}